import { render, staticRenderFns } from "./CConfirmationModal.vue?vue&type=template&id=0ea3a6c4&scoped=true&"
import script from "./CConfirmationModal.vue?vue&type=script&lang=ts&"
export * from "./CConfirmationModal.vue?vue&type=script&lang=ts&"
import style0 from "./CConfirmationModal.vue?vue&type=style&index=0&id=0ea3a6c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea3a6c4",
  null
  
)

export default component.exports